import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "scheduling", spoke: "scheduling", title: "Scheduling", icon: ViewTimelineIcon, order: 43, entries: [
  { label: "Planning board", to: "/app/scheduling/board", permission: "scheduling.schedule.view" },
  { label: "Bottlenecks", to: "/app/scheduling/bottlenecks", permission: "scheduling.schedule.view" },
  { label: "Capacity overrides", to: "/app/masterdata/capacity-overrides", permission: "scheduling.capacity.view" },
  { label: "Employee skills", to: "/app/masterdata/employee-skills", permission: "scheduling.capacity.view" },
  { label: "Sourcing rules", to: "/app/masterdata/sourcing-rules", permission: "scheduling.sourcing.view" },
] });
